(function () {
    'use strict';

    angular
        .module('backApp')
        .controller('ProcessDialogController', ProcessDialogController);

    ProcessDialogController.$inject = ['$scope', '$uibModalInstance', '$uibModal', 'entity', 'Process',
        'MessageService', 'AlertService'
    ];

    function ProcessDialogController($scope, $uibModalInstance, $uibModal, entity, Process,
        MessageService, AlertService) {
        var vm = this;

        vm.process = entity ? entity : {};
        vm.quantityType = (vm.process.type == 'HOT_STAMP' || vm.process.type == 'UV' || vm.process.type === 'FLUORESCENT')? 'MULTIPLE' : 'SINGLE'
        if(!vm.process.unit){
            vm.process.unit = 'mm'
        }
        vm.clear = clear;
        vm.save = save;
        vm.onUnitChange = onUnitChange;
        vm.onEpitaxyValueChange = onEpitaxyValueChange;
        vm.onEpitaxyKeyDown = onEpitaxyKeyDown;
        vm.getEpitaxyMin = getEpitaxyMin;
        vm.getEpitaxyMax = getEpitaxyMax;
        vm.getEpitaxyStep = getEpitaxyStep;

        function onUnitChange() {
            vm.process.epitaxyValue = null;
        }

        function onEpitaxyKeyDown(e) {
            var key = e.key;
            if (key === '-' || key === '+' || key === 'e' || key === 'E') {
                e.preventDefault();
                return;
            }
            if (key === '.' && vm.process.unit === 'px') {
                e.preventDefault();
                return;
            }
            if (key === '.' && vm.process.unit === 'mm') {
                var current = String(vm.process.epitaxyValue || '');
                if (current.indexOf('.') !== -1) {
                    e.preventDefault();
                }
            }
        }

        function onEpitaxyValueChange() {
            var v = vm.process.epitaxyValue;
            if (v === null || v === undefined || v === '') {
                return;
            }
            var num = Number(v);
            if (isNaN(num)) {
                vm.process.epitaxyValue = null;
                return;
            }
            if (vm.process.unit === 'mm') {
                if (num < 0) num = 0;
                if (num > 10) num = 10;
                num = Math.floor(num * 10) / 10;
                vm.process.epitaxyValue = num;
            } else if (vm.process.unit === 'px') {
                if (num < 0) num = 0;
                if (num > 100) num = 100;
                num = Math.floor(num);
                vm.process.epitaxyValue = num;
            }
        }

        function getEpitaxyMin() {
            return 0;
        }

        function getEpitaxyMax() {
            return vm.process.unit === 'mm' ? 10 : (vm.process.unit === 'px' ? 100 : undefined);
        }

        function getEpitaxyStep() {
            return vm.process.unit === 'mm' ? 0.1 : (vm.process.unit === 'px' ? 1 : 'any');
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if(vm.process.epitaxy){
                if(vm.process.epitaxyValue === null || vm.process.epitaxyValue === undefined || vm.process.epitaxyValue === ''){
                    MessageService.error("请填写扩收参数");
                    return;
                }
                var value = Number(vm.process.epitaxyValue);
                if(vm.process.unit === 'mm'){
                    if(isNaN(value) || value < 0 || value > 10 || !/^\d+(\.\d)?$/.test(String(vm.process.epitaxyValue))){
                        MessageService.error("扩收参数必须为0-10且最多一位小数");
                        return;
                    }
                } else if(vm.process.unit === 'px'){
                    if(isNaN(value) || value < 0 || value > 100 || !/^\d+$/.test(String(vm.process.epitaxyValue))){
                        MessageService.error("扩收参数必须为0-100的整数");
                        return;
                    }
                } else {
                    MessageService.error("请选择单位");
                    return;
                }
            }else{
                vm.process.epitaxy = null;
                vm.process.epitaxyValue = 0;
            }
            vm.isSaving = true;
            var data = {
                id: vm.process.id,
                name: vm.process.name,
                alias: vm.process.alias,
                type: vm.process.type,
                quantityType: vm.process.quantityType,
                spotColor: vm.process.spotColor,
                epitaxy: vm.process.epitaxy,
                epitaxyValue: vm.process.epitaxyValue,
                remark: vm.process.remark,
                unit: vm.process.unit,
                cancelled: vm.process.cancelled || false,
                origin: vm.process.origin || 'STORE',
                operationValues: vm.process.operationValues || []
            };
            if (data.id) {
                Process.update(data, onSaveSuccess, onSaveError);
            } else {
                Process.save(data, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('backApp:processUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
